import React from "react";
import { Link } from "react-router-dom";

const AuthSuccessPanel = ({ actionLabel, actionTo, children, title }) => (
  <div className="auth-success-panel" role="status">
    <div className="auth-success-visual" aria-hidden="true">
      <div className="auth-success-orbit" />
      <div className="auth-success-envelope">
        <svg viewBox="0 0 48 48" focusable="false" aria-hidden="true">
          <path d="M9 15.5h30v20H9z" />
          <path d="m10 16 14 12 14-12" />
          <path d="m10 35 11-10" />
          <path d="m38 35-11-10" />
        </svg>
      </div>
    </div>
    <div className="auth-success-copy">
      <h2>{title}</h2>
      {children}
    </div>
    <Link className="primary auth-success-action" to={actionTo}>
      {actionLabel}
    </Link>
  </div>
);

export default AuthSuccessPanel;
